export function createCard(token, postal, companyId) {
  return async (dispatch, getState, {api}) => {
    const {data} = await api.createCard({token, postal});
    dispatch({type: 'company/setSelectedCard', card: data.card, companyId});
    return data.card;
  }
}
